// The function that allows us to see each element
// that can appear outside the iframe in development mode
export const applyDevelopmentUI = () => {
  if (window.location.hostname === 'localhost') {
    document.body.style.background = 'grey';
  }
};
